import React from 'react'

export default function Main(props) {
  return (
    <main className={[props.className, 'flex-1']}>
      {props.children}
    </main>
  )
}
